module.exports = __webpack_public_path__ + "static/media/loader.e62f80ff.gif";